import { render } from "./NerpathamList.vue?vue&type=template&id=a9729cf8&scoped=true"
import script from "./NerpathamList.vue?vue&type=script&lang=js"
export * from "./NerpathamList.vue?vue&type=script&lang=js"

import "./NerpathamList.vue?vue&type=style&index=0&id=a9729cf8&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9729cf8"]])

export default __exports__